export default __webpack_public_path__ + "static/img/geocoder-arrow-mobile.df2b615.svg";